import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  ref: "wrapper",
  class: "relative"
}
const _hoisted_2 = { class: "upload-type-menu absolute z-10 mt-1 w-full bg-card border border-border shadow-sm overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_option_drop_down_row = _resolveComponent("option-drop-down-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "upload-type-trigger w-full flex items-center justify-between px-4 py-2.5 border border-input bg-background text-sm text-foreground hover:bg-accent/50 transition-colors focus:outline-none focus:ring-2 focus:ring-ring",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(_ctx.label ? '!text-sm text-foreground' : '!text-sm text-muted-foreground')
      }, _toDisplayString(_ctx.label || 'Choose an action…'), 3),
      (_openBlock(), _createElementBlock("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        class: _normalizeClass(['h-4 w-4 text-muted-foreground transition-transform', _ctx.isOpen ? 'rotate-180' : '']),
        "aria-hidden": "true"
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("path", { d: "m6 9 6 6 6-6" }, null, -1)
      ]))], 2))
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_option_drop_down_row, {
        text: "Import additional data",
        onHandleClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectType(1)))
      }),
      _createVNode(_component_option_drop_down_row, {
        text: "Delete all data / import new data",
        onHandleClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectType(2)))
      }),
      (_ctx.havePermissionToDownload)
        ? (_openBlock(), _createBlock(_component_option_drop_down_row, {
            key: 0,
            text: "Download all partner data",
            onHandleClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectType(3)))
          }))
        : _createCommentVNode("", true),
      (_ctx.havePermissionToDownload)
        ? (_openBlock(), _createBlock(_component_option_drop_down_row, {
            key: 1,
            text: "Download selected partners data",
            onHandleClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectType(4)))
          }))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.isOpen]
    ])
  ], 512))
}